module.exports = __webpack_public_path__ + "static/media/team-2.c67c778a.avif";